<template>
  <page-column>
    <page-row>
      <router-view></router-view>
    </page-row>
  </page-column>
</template>

<script>
import { lib } from "../../../comm/assets/js/lib";
export default {
  components: {
  },
  data() {
    return {
      activeIndex: "1",
    };
  },
  methods: {},
  created() {
    if (
        lib.cookie.get("Hpc-Platform-Token") &&
        lib.sessionStorage.get("name")
      ) {
        this.$store.commit("updateUser", {
          name: lib.sessionStorage.get("name"),
          avatar: lib.sessionStorage.get("avatar"),
          balance: lib.sessionStorage.get("balance"),
        })
      } else {
        this.$router.push({ path: "/login" })
      }
  },
  mounted() {

  },
}
</script>



// WEBPACK FOOTER //
// src/workspace/views/layout/Single.vue